/* customGroup/actions */
import { action } from "typesafe-actions";
import { CustomGroup, CustomGroupActionTypes, Data } from "./types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { insert } from "../../repo/api";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(CustomGroupActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: CustomGroup) =>
  action(CustomGroupActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(CustomGroupActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  callback?: (err: string | null, data: CustomGroup | null) => unknown
) => action(CustomGroupActionTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: CustomGroup) =>
  action(CustomGroupActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(CustomGroupActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(CustomGroupActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () =>
  action(CustomGroupActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(CustomGroupActionTypes.DELETE_ERROR, error);

export const create = createAsyncThunk(
  CustomGroupActionTypes.CREATE,
  async (customGroup: Data) => {
    const response = await insert({
      id: undefined,
      nestedResourcePath: ["groups"],
      data: {
        data: customGroup,
      },
    });
    if (response.data.data) {
      return response.data;
    } else {
      return response.data.errors;
    }
  }
);
